import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { GenericIcon } from '../../generic/icon/generic-icon';
import { COLORS } from '../../constants';
export const Icon = ({ definition }) => {
    const { width, height, color = COLORS.SECONDARY_SHAPE_STROKE } = definition;
    const { PointerArea } = useContext(ComponentContext);
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericIcon, { size: width, type: definition.icon, fill: color }),
        React.createElement(PointerArea, { width: width, height: height })));
};
//# sourceMappingURL=icon.js.map